//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Message } from 'element-ui'
export default {
  props:['shopId'],
  data() {
    return {
      initShopArea:'全部',
      shopAreaList:[],
      initShopBrand:'全部',
      shopBrandList:[],
      dialogVisible:true,
      selectGoodsState:false,
      // dialog查看中的订单时间
      dialogTime:'2021-12-14',
      // dialog查看初始的数据
      infoGoodsData:[],
      // 已经选择对应的商品的数据
      alreadyGoodsData:[],
      // dialog查看推荐的商品
      goodsRmd:[],
      // dialog查看用于展示的商品
      goodsDableData:[],
      // dialog查看全选
      goodsListState:false,
      // dialog查看订单金额
      goodsAllMoney:0,
      selectBtnState:false,
      accountArr:[
      ],
      accountArrValue:'',
      goodsDeleteState:false,
      goodsDeleteArr:[],
      // 被选择的商品
      selectGoods:{goodsName:''},
      selectGoodsTableData:[],
      shopName:'',
      sysShopId:'',
      userPhone:'',
      address:'',
      pageSizeValue:5,
      total:100,
      pageNo:1,
      goodsDetail:{},
      orderJson:[],
      inpState:true,
      reg: RegExp(/^1(3|4|5|6|7|8|9)\d{9}$/)
    }
  },
  created(){
    this.info()
  },
  methods:{
    info(){
      this.$axios.post('/mtea/stock/order/info', {shopId:this.shopId}).then(res => {
        this.orderJson = JSON.stringify(res)
        this.infoGoodsData = []
        this.goodsRmd = []
        for(let i = 0;i<res.itemList.length;i++){
          if(res.itemList[i].sysGoodsId && !res.itemList[i].goodsId){
            // 初始的数据
            res.itemList[i].type = '0'
            this.infoGoodsData.push(res.itemList[i])
          }else if(res.itemList[i].sysGoodsId && res.itemList[i].goodsId){
            // 已经选择对应商品
            res.itemList[i].checked = false
            res.itemList[i].orderMoney = res.itemList[i].price/100
            res.itemList[i].payMoney = res.itemList[i].orderMoney * res.itemList[i].count
            res.itemList[i].type = '1'
            res.itemList[i].goodsExtra = JSON.parse(res.itemList[i].goodsExtra)
            res.itemList[i] = {...res.itemList[i],...res.itemList[i].goodsExtra}
            this.alreadyGoodsData.push(res.itemList[i])
          }else{
            // 推荐的商品
            res.itemList[i].type = '2'
            res.count = 0
            console.log()
            res.itemList[i].goodsExtra = JSON.parse(res.itemList[i].goodsExtra)
            res.itemList[i] = {...res.itemList[i],...res.itemList[i].goodsExtra}
            this.goodsRmd.push(res.itemList[i])
          }
        }
        this.unDateGoods()
        this.accountArr = []
        this.shopName = res.shopName
        this.userPhone = res.userPhone
        this.sysShopId = res.sysShopId
        this.address = res.address
        res.staffList.forEach((e)=>{
          let data = {value:e.staffId,label:e.userName+':'+e.userPhone}
          this.accountArr.push(data)
          if(res.sysStaffId && res.sysStaffId === e.staffId){
            this.accountArrValue = e.staffId
          }else{
            this.accountArrValue = e.staffId
          }
        })
      })
      // })
    },
  //   // 总账
    goodsAllMoneyFun(){
      this.goodsAllMoney = 0
      this.goodsDableData.forEach(e => {
        if(e.type === '1'){
          this.goodsAllMoney += Number(e.payMoney)
        }
      });
      this.goodsAllMoney = this.goodsAllMoney.toFixed(2)
    },
  //   // 数量变化
    itemCountChange(row){
      console.log(row)
      for(let i = 0;i<this.alreadyGoodsData.length;i++){
        if(this.alreadyGoodsData[i].sysGoodsId === row.sysGoodsId){
          this.alreadyGoodsData[i].payMoney = Number(row.orderMoney * row.count).toFixed(2)
          break
        }
      }
      this.unDateGoods()
    },
    //单选
    checkBtnFun(){
      let state = true
      this.goodsDableData.forEach(e => {
        if(e.type !== '2' && !e.checked){
          state = false
        }
      });
      this.goodsListState = state
    },
  //   // 全选事件
    checkAll(){
      if(this.goodsListState){
        this.goodsDableData.forEach(e => {
          if(e.type !== '2'){
            e.checked = true
          }
        });
      }else{
        this.goodsDableData.forEach(e => {
          if(e.payMoney !== '2'){
            e.checked = false
          }
        });
      }
    },
  //   // 删除商品
    deleteGoods(goodsArr){
      this.goodsDeleteState = false
      for(let i = 0;i<goodsArr.length;i++){
        switch(goodsArr[i].type){
          case "0" :
            for(let j = 0;j<this.infoGoodsData.length;j++){
              if(this.infoGoodsData[j].sysGoodsId === goodsArr[i].sysGoodsId){
                this.infoGoodsData.splice(j,1)
              }
            }
            break;
          case "1" :
             for(let j = 0;j<this.alreadyGoodsData.length;j++){
              if(this.alreadyGoodsData[j].sysGoodsId === goodsArr[i].sysGoodsId){
                this.alreadyGoodsData.splice(j,1)
              }
            }
            break;
          case "2" :
            for(let j = 0;j<this.goodsRmd.length;j++){
              if(this.goodsRmd[j].goodsId === goodsArr[i].goodsId){
                this.goodsRmd.splice(j,1)
              }
            }
            break;
        }
      }
      this.unDateGoods()
    },
  //   // 底部更多删除
    moreDelete(){
      this.goodsDeleteArr = []
      this.goodsDableData.forEach(e => {
        if(e.checked === true){
          this.goodsDeleteArr.push(e)
        }
      });
      this.goodsDeleteState = true
    },
    unDateGoods(){
      this.goodsDableData = []
      this.alreadyGoodsData.forEach(e => {
        this.goodsDableData.push(e)
      });
      this.infoGoodsData.forEach(e => {
        this.goodsDableData.push(e)
      });
      this.goodsRmd.forEach(e => {
        this.goodsDableData.push(e)
      });
      this.goodsAllMoneyFun()
    },
    saveData(state=false){
      if(this.userPhone === ''){
        this.$message('请输入手机号！');
        this.inpState = false
        this.$refs.inventory.firstElementChild.scrollTo(0,0);
        return
      }
      this.orderJson = JSON.parse(this.orderJson)
      this.orderJson.itemList = []
      this.orderJson.num = this.orderJson.itemList.length
      this.goodsDableData.forEach(e => {
        if(e.type !== '0'){
          if(e.type === '2'){
            e.count = 0
            e.recommend = 1
          }else{
            e.recommend = 0
          }
          this.orderJson.itemList.push(e)
        }
      });
      if(this.orderJson.itemList.length === 0){
        this.$message('请先选择商品或者推荐商品');
        this.info()
        return
      }
      this.orderJson.userPhone = this.userPhone
      this.orderJson.address = this.address
      this.orderJson.orderMoney=Number(this.goodsAllMoney*100)
      this.orderJson = JSON.stringify(this.orderJson)
      console.log({'orderJson':this.orderJson,shopId:this.sysShopId})
      this.$axios.post('/mtea/stock/order/add',{'orderJson':this.orderJson,shopId:this.sysShopId}).then(res => {
        if(state){
          this.sendGoodsOrder(res)
        }else{
          this.$message({
            message: '保存成功！',
            type: 'success'
          });
        }
      })
    },
    sendGoodsOrder(res){
      let param = {
        shopId:this.sysShopId,
        stockOrderId:res.stockOrderId,
        stockOrderItemId:res.stockOrderId,
        sysStaffId:this.accountArrValue,
        orderJson:this.orderJson
      }
      console.log(param)
      this.$axios.post('/mtea/stock/order/push',param).then(res => {
        console.log(res)
        this.$message({
          message: '缺货单发送成功！',
          type: 'success'
        });
        this.emitSub()
      })

    },
    emitSub(){
      this.$emit('invSubState')
    },
    selectGoodsFun(row){
      this.$axios.get('/mtea/store/admin/goods/category/list',{params:{}}).then(res=>{
        this.shopBrandList = res
        this.shopBrandList.unshift({name:'全部',categoryId:'全部'})
      })
      this.$axios.get('/mtea/store/admin/goods/brand/list',{params:{}}).then(res=>{
        this.shopAreaList = res
        this.shopAreaList.unshift({name:'全部',brandId:'全部'})
      })
      this.pageNo = 1
      if(row === ''){
        this.selectGoods.goodsName = ''
        this.goodsDetail = {}
        this.selectGoodsState = true
        this.selectBtnState = false
        let method = {orderParams:'publishTime',status: 1,pageNo: 1,pageSize: this.pageSizeValue}
        this.infoGoodsList(method)
      }else{
        this.goodsDetail = row
        this.selectGoods.goodsName = row.stockName
        this.selectGoodsState = true
        this.selectBtnState = true
        let method = {q:this.selectGoods.goodsName,orderParams:'publishTime',status: 1,pageNo: 1,pageSize: this.pageSizeValue}
        this.infoGoodsList(method)
      }
    },
    infoGoodsClick(state = false){
      console.log(this.initShopBrand,this.initShopArea)
      if(state){
        this.pageNo = 1
      }
      let method = {orderParams:'publishTime',status: 1,pageNo:this.pageNo,pageSize:this.pageSizeValue}
      if(this.selectGoods.goodsName != ''){
        method.q = this.selectGoods.goodsName
      }
      this.infoGoodsList(method)
    },
  //   // 请求商城数据
    infoGoodsList(method){
      if(this.initShopBrand !== '全部')method.cid = this.initShopBrand
      if(this.initShopArea !== '全部')method.bid = this.initShopArea
      this.$axios.get('/mtea/store/admin/goods/list', {params:method}).then(res => {
        res.records.forEach(e=>{
          e.orderMoney = e.price/100
        })
        this.tableData = res.records
        this.total = res.total
        this.selectGoodsTableData = res.records
      })
    },
    // 选择商城数据
    selectGoodsClickFun(row,state){
      if(this.goodsDetail != {} && state && this.goodsDetail.type === '0'){
        // 选择
        row.checked = false
        row.payMoney = row.orderMoney
        row.count = 1
        row.type = '1'
        for(let i = 0;i<this.infoGoodsData.length;i++){
          if(this.infoGoodsData[i].sysGoodsId === this.goodsDetail.sysGoodsId){
            // this.infoGoodsData[i] = row
            row.stockName = this.infoGoodsData[i].stockName
            row.sysGoodsId = this.infoGoodsData[i].sysGoodsId
            row.sysStockCount = this.infoGoodsData[i].sysStockCount
            this.infoGoodsData.splice(i,1)
            this.alreadyGoodsData.push(row)
            break;
          }
        }
        this.selectGoodsState = false
      }else if(this.goodsDetail != {} && state && this.goodsDetail.type === '1'){
        // 替换
        row.checked = false
        row.payMoney = row.orderMoney
        row.count = 1
        row.type = '1'
        for(let i = 0;i<this.alreadyGoodsData.length;i++){
          if(this.alreadyGoodsData[i].sysGoodsId === this.goodsDetail.sysGoodsId){
            row.stockName = this.alreadyGoodsData[i].stockName
            row.sysGoodsId = this.alreadyGoodsData[i].sysGoodsId
            row.sysStockCount = this.alreadyGoodsData[i].sysStockCount
            this.alreadyGoodsData[i] = row
            this.alreadyGoodsData[i].stockName = this.goodsDetail.stockName 
            break;
          }
        }
        this.selectGoodsState = false
      }else{
        // 手动添加
        row.type = '2'
        row.count = 0
        this.goodsRmd.push(row)
        this.selectGoodsState = false
      }
      this.unDateGoods()
    },
    sizeChange(num){
      this.pageSizeValue = num
      this.infoGoodsClick()
    },
    currentChange(num){
      this.pageNo = num
      this.infoGoodsClick()
    },
    // 关闭前的回调
    beforeClose(){
      // console.log('关闭前的回调',this.dialogVisible)
      if(!this.dialogVisible)this.emitSub()
    }
  }

}
